
import { PromoPartnerFamily } from './promo-partner-family.entity';
import { BaseEntity } from 'src/app/tools/models/baseEntity';

export class PromoPartnerFamilyPromo extends BaseEntity {
  
  promoPartnerFamily  : PromoPartnerFamily;
  startDate           : Date;
  endDate           : Date;
 
    constructor() {
      super()
    }
}
